/**
 * LoadingState Component — Skeleton loaders and spinners (refined)
 */
import React from 'react';

export function Spinner({ size = 'md', className = '' }) {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
    lg: 'w-7 h-7',
    xl: 'w-10 h-10'
  };

  return (
    <div className={`animate-spin ${sizeClasses[size]} ${className}`}>
      <svg className="w-full h-full" viewBox="0 0 24 24" fill="none">
        <circle className="opacity-20" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="3" />
        <path
          className="opacity-80"
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        />
      </svg>
    </div>
  );
}

export function SkeletonCard() {
  return (
    <div className="px-4 py-3.5 border-b border-stone-100/60 animate-pulse">
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 bg-stone-200/60 rounded-xl" />
        <div className="flex-1 space-y-2">
          <div className="h-3.5 bg-stone-200/60 rounded-lg w-3/4" />
          <div className="h-2.5 bg-stone-100/80 rounded-lg w-1/2" />
          <div className="flex gap-1 mt-1.5">
            <div className="h-4 bg-stone-100/80 rounded-md w-14" />
            <div className="h-4 bg-stone-100/80 rounded-md w-18" />
          </div>
        </div>
      </div>
    </div>
  );
}

export function SkeletonDetail() {
  return (
    <div className="p-6 animate-pulse">
      <div className="flex items-start gap-3.5 mb-5">
        <div className="w-14 h-14 bg-stone-200/60 rounded-2xl" />
        <div className="flex-1 space-y-2">
          <div className="h-4 bg-stone-200/60 rounded-lg w-3/4" />
          <div className="h-3 bg-stone-100/80 rounded-lg w-1/2" />
        </div>
      </div>
      <div className="space-y-3">
        <div className="h-20 bg-stone-100/60 rounded-2xl" />
        <div className="h-28 bg-stone-100/60 rounded-2xl" />
        <div className="h-20 bg-stone-100/60 rounded-2xl" />
      </div>
    </div>
  );
}

export function LoadingState({ message = 'Loading...', showSpinner = true }) {
  return (
    <div className="flex flex-col items-center justify-center p-8 text-stone-400">
      {showSpinner && <Spinner size="lg" className="text-primary-500 mb-3" />}
      <p className="text-sm font-medium">{message}</p>
    </div>
  );
}

export default LoadingState;
